<template>
  <div id="rating">
    <div class="rating-text">评级</div>
    <div class="star-list">
      <div v-for="(item, index) in MAX_STAR_NUMBER"
           :key="index"
           :class="[starNum > index ? 'star-active' : 'star']"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'rating',
  data () {
    return {
      MAX_STAR_NUMBER: 5
    }
  },
  computed: {
    ...mapGetters([
      'getQuestionDetail'
    ]),
    starNum () {
      if (this.getQuestionDetail.status === 2 && this.getQuestionDetail.isSolved === 1) {
        return this.getQuestionDetail.percent
      } else {
        return 0
      }
    }
  }
}
</script>

<style scoped>
#rating {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  margin-top: 12px;
  line-height: 44px;
  background: #fff;
}
.rating-text {
  padding-left: 41px;
  background: url("../../icons/star-blue.svg") no-repeat 17px center;
}
.star-list {
  display: flex;
  justify-content: space-between;
  width: 30%;
  max-width: 150px;
  padding-right: 14px;
}
.star-active {
  width: 20px;
  height: 41px;
  background: url("../../icons/star-yellow.svg") no-repeat center center;
  background-size: 20px 20px;
}
.star {
  width: 20px;
  height: 41px;
  background: url("../../icons/star-gray.svg") no-repeat center center;
  background-size: 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/rating/rating.vue